import React, { useEffect, useState } from 'react';
import { Button, Form, message } from 'antd';
import {
  FullscreenExitOutlined,
  FullscreenOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import intl from 'react-intl-universal';
import { isNil } from '@/utils/number';
import { storage } from '@/utils';
import styles from './Zoom.module.scss';

const percentageList = [0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1.0, 1.1, 1.25, 1.5, 1.75, 2, 3, 4];

const ZoomModal = () => {
  const [index, setIndex] = useState<number>(7);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  const win: any = window;

  const handleMinus = () => {
    if (index > 0) {
      setIndex(index - 1);
      storage.set('screenZoomIndex', index - 1);
      win.electron?.ipcRenderer.zoomChange(percentageList[index - 1]);
    }
  };

  const handlePlus = () => {
    if (index < percentageList.length - 1) {
      setIndex(index + 1);
      storage.set('screenZoomIndex', index + 1);
      win.electron?.ipcRenderer.zoomChange(percentageList[index + 1]);
    }
  };

  const handleFullScreen = () => {
    if (!isFullScreen) {
      message.success(intl.get('zoom_quit_tips'));
    }
    storage.set('fullScreenFlag', !isFullScreen);
    win.electron?.ipcRenderer.screenResize(isFullScreen ? 'full-screen-Exit' : 'full-screen');
  };

  const handleClose = () => {
    win.electron?.ipcRenderer.settingClose();
  };

  useEffect(() => {
    const screenZoomIndex = storage.get('screenZoomIndex');
    win.electron?.ipcRenderer.zoomChange(percentageList[JSON.parse(screenZoomIndex)] || 1);

    win.electron?.ipcRenderer.screenResize(
      JSON.parse(storage.get('fullScreenFlag')) ? 'full-screen' : 'full-screen-Exit',
    );

    win.electron?.ipcRenderer.on('screen-resize-result', (flag) => {
      setIsFullScreen(flag);
      storage.set('fullScreenFlag', flag);
    });
  }, []);

  const number = percentageList[index] * 100;

  return (
    <>
      <div className={styles.container}>
        <div>
          <Form.Item label={intl.get('zoom_label')} />
        </div>
        <div className={styles.zoom}>
          <div className={styles.step}>
            <div>{intl.get('zoom_text')}</div>
            <div className={styles.minus} onClick={handleMinus}>
              <MinusOutlined />
            </div>
            <div className={styles.content}>{!isNil(number) ? `${number?.toFixed(0)}%` : ''}</div>
            <div className={styles.plus} onClick={handlePlus}>
              <PlusOutlined />
            </div>
            <div className={styles.fullScreen} onClick={handleFullScreen}>
              {isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
            </div>
          </div>
        </div>
        <div className={styles.btnGroup}>
          <Button type="primary" onClick={handleClose}>
            {intl.get('app_btn_close')}
          </Button>
        </div>
      </div>
    </>
  );
};
export default ZoomModal;
